import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["input", "from", "to"]
  static values = { mode: { type: String, default: "single" } }

  connect() {
    if (this.modeValue === "range") {
      this.picker = flatpickr(this.inputTarget, {
        mode: "range",
        inline: true,
        showMonths: window.innerWidth >= 640 ? 2 : 1,
        dateFormat: "Y-m-d",
        defaultDate: [this.fromTarget.value, this.toTarget.value],
        onChange: (dates) => this.pick(dates)
      })
    } else {
      this.picker = flatpickr(this.element, { altInput: true, altFormat: "d M Y", dateFormat: "Y-m-d" })
    }
  }

  disconnect() {
    this.picker?.destroy()
    this.picker = null
  }

  // Range picked: write from/to, then emit flatpickr:selected (the filter form auto-submits on it).
  pick(dates) {
    if (dates.length < 2) return
    this.fromTarget.value = this.picker.formatDate(dates[0], "Y-m-d")
    this.toTarget.value = this.picker.formatDate(dates[1], "Y-m-d")
    this.dispatch("selected")
  }
}
